var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Checkbox, Switch } from '@snack-uikit/toggles';
import { extractSupportProps } from '@snack-uikit/utils';
import { ItemContent } from '../../../helperComponents';
import { useCollapseLevelContext, useNewListContext, useOpenListContext, useSelectionContext, } from '../../Lists/contexts';
import commonStyles from '../styles.module.css';
import { isContentItem } from '../utils';
import { CHECKBOX_SIZE_MAP } from './constants';
import styles from './styles.module.css';
export function BaseItem(_a) {
    var _b;
    var { beforeContent, afterContent, content, onClick, onMouseDown, id, expandIcon, disabled, open, itemRef, switch: switchProp, onKeyDown, onFocus, indeterminate, checked: checkedProp, onSelect, onOpenNestedList, isParentNode, className, inactive, itemWrapRender } = _a, rest = __rest(_a, ["beforeContent", "afterContent", "content", "onClick", "onMouseDown", "id", "expandIcon", "disabled", "open", "itemRef", "switch", "onKeyDown", "onFocus", "indeterminate", "checked", "onSelect", "onOpenNestedList", "isParentNode", "className", "inactive", "itemWrapRender"]);
    const interactive = !inactive;
    const { size = 's', marker, contentRender, firstItemId, focusFlattenItems } = useNewListContext();
    const { level = 0 } = useCollapseLevelContext();
    const { closeDroplist, closeDroplistOnItemClick } = useOpenListContext();
    const { value, onChange, mode, isSelectionSingle, isSelectionMultiple } = useSelectionContext();
    const isChecked = isSelectionSingle ? (checkedProp !== null && checkedProp !== void 0 ? checkedProp : value === id) : (checkedProp !== null && checkedProp !== void 0 ? checkedProp : value === null || value === void 0 ? void 0 : value.includes(id !== null && id !== void 0 ? id : ''));
    const handleChange = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    };
    const handleItemMouseDown = (e) => {
        if (disabled)
            return;
        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
    };
    const handleItemFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        e.stopPropagation();
    };
    const handleCheckboxChange = () => {
        if (isParentNode && onSelect) {
            onSelect();
        }
        else {
            handleChange();
        }
    };
    const handleItemClick = (e) => {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            if (interactive) {
                if (!isParentNode) {
                    handleChange();
                }
            }
            if (!isSelectionMultiple && closeDroplistOnItemClick) {
                closeDroplist();
            }
        }
    };
    const handleItemKeyDown = (e) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        if (e.key === 'ArrowRight' && onOpenNestedList) {
            onOpenNestedList(e);
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (e.code === 'Space' || e.key === 'Enter' || e.key === ' ') {
            if (isSelectionMultiple && isParentNode && onSelect) {
                onSelect();
            }
            !isParentNode && handleChange();
            // TODO: should pass an event here?
            !isParentNode && (handleItemClick === null || handleItemClick === void 0 ? void 0 : handleItemClick(e));
            e.stopPropagation();
            e.preventDefault();
        }
    };
    const handleCheckboxClick = (e) => {
        if (isParentNode) {
            e.stopPropagation();
        }
    };
    const props = extractSupportProps(rest);
    const itemJSX = (_jsx("div", { className: cn(commonStyles.itemWrapper, styles.innerWrapper, className), "data-inactive": inactive || undefined, "data-disabled": disabled || undefined, "data-variant": mode || undefined, "data-checked": (isParentNode && (indeterminate || isChecked)) || (isChecked && !switchProp) || undefined, children: _jsxs("li", { "data-type": 'outside', role: 'menuitem', "data-test-id": props['data-test-id'] || 'list__base-item_' + id, "data-checked": (isParentNode && (indeterminate || isChecked)) || (isChecked && !switchProp) || undefined, ref: itemRef, className: cn(commonStyles.listItem, styles.droplistItem), "data-size": size, onClick: handleItemClick, onMouseDown: handleItemMouseDown, tabIndex: firstItemId && id === focusFlattenItems[firstItemId].originalId ? 0 : -1, "data-non-pointer": inactive && !onClick, "data-variant": mode || undefined, "data-open": open || undefined, onKeyDown: handleItemKeyDown, onFocus: handleItemFocus, style: { '--level': level }, children: [!switchProp && isSelectionSingle && marker && !isParentNode && interactive && (_jsx("div", { className: styles.markerContainer, "data-test-id": 'list__base-item-marker' })), !switchProp && isSelectionMultiple && interactive && (_jsx("div", { className: styles.checkbox, children: _jsx(Checkbox, { size: CHECKBOX_SIZE_MAP[size !== null && size !== void 0 ? size : 's'], disabled: disabled, tabIndex: -1, onChange: isParentNode ? handleCheckboxChange : undefined, checked: isChecked, "data-test-id": 'list__base-item-checkbox', onClick: handleCheckboxClick, indeterminate: indeterminate }) })), beforeContent && _jsx("div", { className: styles.beforeContent, children: beforeContent }), content && isContentItem(content) ? (((_b = contentRender === null || contentRender === void 0 ? void 0 : contentRender({ id, content, disabled })) !== null && _b !== void 0 ? _b : _jsx(ItemContent, Object.assign({ disabled: disabled }, content)))) : (_jsxs("div", { className: styles.content, children: [" ", content, " "] })), afterContent, switchProp && interactive && (_jsx(Switch, { disabled: disabled, checked: isChecked, "data-test-id": 'list__base-item-switch' })), !switchProp && expandIcon && _jsx("span", { className: styles.expandableIcon, children: expandIcon })] }) }));
    if (!itemWrapRender) {
        return itemJSX;
    }
    return itemWrapRender(itemJSX);
}
